import { sendHubspotForm } from 'API/hubspot-api/hubspot-api';
import {
    googleSignupFormId,
    HubSpotFieldNames,
    signupFormId,
} from 'features/authentication/utils/constants';
import {
    GoogleSignupFullStepForm,
    SignupFullStepForm,
} from 'features/authentication/signup/components/signup-full-form-step/signup-full-form-step';
import { WebSightsData } from 'features/authentication/types/types';
import { getCookieValueByName } from 'shared/utils/cookies/utils';

const HUBSPOT_LEAD_FORM_ID = '12b4570b-df3f-46c3-9bd6-eb5dd24dd1cb';

export const registerHubspotLead = (email: string, urlUtmParams: Record<string, string | null>) => {
    void sendHubspotForm(HUBSPOT_LEAD_FORM_ID, [
        {
            name: HubSpotFieldNames.email,
            value: email || '',
        },
        {
            name: HubSpotFieldNames.utmSource,
            value: urlUtmParams.utm_source || '',
        },
        {
            name: HubSpotFieldNames.utmMedium,
            value: urlUtmParams.utm_medium || '',
        },
        {
            name: HubSpotFieldNames.utmCampaign,
            value: urlUtmParams.utm_campaign || '',
        },
    ]);
};

export const sendHubspotGoogleSignupForm = (
    email: string,
    method: string,
    formData: GoogleSignupFullStepForm,
) => {
    void sendHubspotForm(googleSignupFormId, [
        {
            name: HubSpotFieldNames.company,
            value: formData.company,
        },
        {
            name: HubSpotFieldNames.jobTitle,
            value: formData.jobTitle,
        },
        {
            name: HubSpotFieldNames.email,
            value: email,
        },
        {
            name: HubSpotFieldNames.phone,
            value: formData.phone,
        },
        {
            name: HubSpotFieldNames.signupMethod,
            value: method,
        },
    ]);
};

export const sendHubspotSignupForm = (
    email: string,
    method: string,
    formData: SignupFullStepForm,
    urlUtmParams: Record<string, string | null>,
) => {
    const wsData: WebSightsData = getCookieValueByName('_ws_data');

    void sendHubspotForm(signupFormId, [
        {
            name: HubSpotFieldNames.firstname,
            value: formData.firstName,
        },
        {
            name: HubSpotFieldNames.lastname,
            value: formData.lastName,
        },
        {
            name: HubSpotFieldNames.company,
            value: formData.company,
        },
        {
            name: HubSpotFieldNames.jobTitle,
            value: formData.jobTitle,
        },
        {
            name: HubSpotFieldNames.email,
            value: email,
        },
        {
            name: HubSpotFieldNames.phone,
            value: formData.phone,
        },
        {
            name: HubSpotFieldNames.signupMethod,
            value: method,
        },
        {
            name: HubSpotFieldNames.WS_companyName,
            value: wsData?.WS_companyName || '',
        },
        {
            name: HubSpotFieldNames.WS_employeeCount,
            value: wsData?.WS_employeeCount || '',
        },
        {
            name: HubSpotFieldNames.WS_industries,
            value: wsData?.WS_industries || '',
        },
        {
            name: HubSpotFieldNames.utmSource,
            value: urlUtmParams.utm_source || '',
        },
        {
            name: HubSpotFieldNames.utmMedium,
            value: urlUtmParams.utm_medium || '',
        },
        {
            name: HubSpotFieldNames.utmCampaign,
            value: urlUtmParams.utm_campaign || '',
        },
    ]);
};
